import { computed, Injectable, inject, signal } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';

@Injectable({ providedIn: 'root' })
export class PwaService {
  private promptEvent = signal(null as any);
  private alertCtrl = inject(AlertController);

  private _isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !(window as any).MSStream;

  initPwaPrompt() {
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      this.promptEvent.set(e);
    });
  }

  isIOS = () => this._isIOS;

  isInstallable = computed(() => this._isIOS || this.promptEvent() !== null);

  async install(): Promise<void> {
    if (this._isIOS) {
      const alert = await this.alertCtrl.create({
        header: 'Install Pharmacin.Net',
        message:
          'Tap the Share button in the toolbar/menu, then scroll down and tap Add to Home Screen.',
        buttons: ['OK'],
      });
      await alert.present();
      return;
    }
    if (!this.promptEvent()) return;
    this.promptEvent().prompt();
    this.promptEvent().userChoice.then(() => {
      this.promptEvent.set(null);
    });
  }
}
